import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { ROUTES } from "config";

export default function HomeRedirect() {
    const { initialized, isAuthenticated } = useSelector((state) => state.auth);

    if (!initialized) {
        return null;
    }

    return (
        <Navigate
            to={isAuthenticated ? ROUTES.DASHBOARD : ROUTES.LOGIN}
            replace
        />
    );
}
